import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { FilterMatchMode } from 'primeng/api';

@Pipe({
 standalone: false,
  name: 'mxTableColoredCell',
})
export class MxTableColoredCellPipe implements PipeTransform {
  constructor() {}
  private color: string;
  transform(
    data: any,
    tableColoredCells: {
      matchMode: FilterMatchMode;
      value: any;
      color: string;
    }[]
  ): string {
    tableColoredCells.forEach((coloredCell) => {
      if (coloredCell.matchMode === FilterMatchMode.EQUALS) {
        if (data == coloredCell.value) {
          this.color = coloredCell.color;
        }
      } else if (coloredCell.matchMode === FilterMatchMode.DATE_BEFORE) {
        if (moment(data).isBefore(moment(coloredCell.value))) {
          this.color = coloredCell.color;
        }
      }
    });
    return this.color;
  }
}

